import { ReactNode } from 'react';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface FormFieldProps {
  /** The id to link label with input */
  id: string;
  /** Label text */
  label: string;
  /** The input/select element */
  children: ReactNode;
  /** Optional additional className */
  className?: string;
  /** Optional status indicator (e.g., saving spinner, saved checkmark) */
  status?: ReactNode;
}

/**
 * Form field wrapper with consistent label spacing
 * Ensures uniform vertical spacing between label and input
 */
export function FormField({ id, label, children, className, status }: FormFieldProps) {
  return (
    <div className={cn('space-y-2', className)}>
      <div className="flex items-center justify-between">
        <Label htmlFor={id}>{label}</Label>
        {status && <span className="flex items-center">{status}</span>}
      </div>
      {children}
    </div>
  );
}
